import type { VideoCategory, VideoPreview } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import { NextSeo } from "next-seo";

import VideosCard from "./VideosCard";
import Carousel from "~/components/Carousel";

const VideosOverview = ({
	featuredVideos,
	categories,
}: {
	featuredVideos: VideoPreview[];
	categories: VideoCategory[];
}) => {
	const { isSignedIn } = useAuth();

	return (
		<>
			<NextSeo title="Videos" />

			<div className="flex w-full flex-col gap-4 phablet:gap-6">
				<div className="flex w-full flex-col gap-4">
					{!isSignedIn && (
						<Carousel title="Featured Videos">
							{featuredVideos?.map((video) => (
								<VideosCard key={video._id} {...video} />
							))}
						</Carousel>
					)}

					{categories.map((category) => (
						<Carousel
							title={category.title}
							key={category._id}
							href={`/videos/categories/${category.slug}`}
						>
							{category.videos?.map((video) => (
								<VideosCard key={video._id} {...video} />
							))}
						</Carousel>
					))}
				</div>
			</div>
		</>
	);
};

export default VideosOverview;
